<template>
  <div class="need-details mt-4">
    <h3 class="text-center">Health Notes</h3>

    <ul>
      <li v-for="(key, k) in selectedDisease" :key="k">
        {{ diseaseDetails(key) }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { diseaseTextByType } from '@/common/helpers';

export default {
  name: 'PlateHealthDetails',
  computed: {
    ...mapGetters({
      disease: 'plates/disease',
      selectedDisease: 'plates/selectedDisease',
    }),
  },
  methods: {
    diseaseDetails(type) {
      return diseaseTextByType(type, this.disease[type]);
    },
  },
};
</script>

<style scoped>
.need-details {
  padding: 20px 30px;
  border: 1px solid black;
}
</style>